<template>
  <div class="sup-name-verify">
    <div
      class="verify-popup"
      :class="{ 'is-below': placeBelow }"
      :style="popupStyle"
      @mousedown.stop
    >
      <div class="title">
        <div class="text">{{ $t("page.validateEmail.title") }}</div>
        <div class="button-group">
          <span class="refresh" @click="reset">
            <i class="el-icon-refresh"></i>
            <span>{{ $t("page.validateEmail.title1") }}</span>
          </span>
          <span class="iconClose" @click="close">
            <i class="el-icon-close"></i>
          </span>
        </div>
      </div>
      <div class="img">
        <div class="backgroup-img">
          <img class="inner-bg-img" :src="backgroupImg" v-if="backgroupImg" />
        </div>
        <div
          class="move-img"
          :style="{ left: `${moveX}px`, top: `${moveTop}px` }"
        >
          <img class="inner-mv-img" :src="moveImg" v-if="moveImg" />
        </div>
      </div>
      <div class="slide" :data-placeholder="$t('page.validateEmail.title3')">
        <div
          class="slider-mask"
          :style="{
            width:
              blcokLeft > 26 ? Number(`${blcokLeft}`) + 40 + 'px' : `${blcokLeft}px`
          }"
        >
          <div
            class="slider-mask-left"
            :class="errorFlag ? 'slider-mask-left-errorleft' : ''"
          ></div>
          <div
            class="slider-mask-center"
            :class="errorFlag ? 'slider-mask-left-errorcenter' : ''"
          ></div>
          <div
            class="slider-mask-right"
            :class="errorFlag ? 'slider-mask-left-errorright' : ''"
            :style="{
              display: errorFlag ? 'none' : blcokLeft > 26 ? 'block' : 'none'
            }"
          ></div>
        </div>
        <div
          class="block"
          :class="errorFlag ? 'blockerror' : ''"
          @mousedown="start"
          :style="{ left: `${blcokLeft}px` }"
        ></div>
      </div>
      <div class="loading" v-if="loading">
        <span>{{ $t("page.validateEmail.title2") }}</span>
      </div>
      <div class="loading" v-if="errorFlag">
        <div
          class="icon-ccui-cancel"
          style="margin-bottom: 10px; cursor: pointer"
          @click="errorFlag = false"
        ></div>
        <span>{{ errorFlagMsg }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// 供应商名称选择前的拼图滑块验证
// 图片获取沿用现有接口 getImageVerifyCode
// 验证通过后广播 success(blcokLeft, id)：
//   blcokLeft —— 手动定位（滑块拖动距离）返回值，对应接口的 checkCodeLimitTime
//   id       —— 后台返回的验证码唯一ID（uuid），对应接口的 businessCode
// 后端校验接口就绪后，父组件通过 validator 传入即可，形如：
//   validator({ checkCodeLimitTime, businessCode }) => Promise<true | { passed, message }>
import { getImageVerifyCode } from "@/api/supRegister";

// 面板尺寸（含底部箭头）
const POPUP_WIDTH = 400;
const POPUP_HEIGHT = 278;
// 滑块可滑动最大距离
const MAX_SLIDE = 305;

export default {
  name: "supplierSliderVerify",
  props: {
    // 定位参考元素，一般传 el-autocomplete.$el，弹层会贴在该输入框上方/下方
    anchor: {
      type: Object,
      required: false,
      default: null
    },
    // 后端校验方法，不传时拖动结束即视为通过
    validator: {
      type: Function,
      required: false,
      default: null
    }
  },
  data() {
    return {
      /** 滑块背景图片 */
      backgroupImg: "",
      /** 滑块图片 */
      moveImg: "",
      /** 是否正在拖动 */
      startMove: false,
      /** 滑块左侧距离 */
      blcokLeft: 0,
      /** 开始滑动的x轴 */
      startX: 0,
      /** 验证码唯一ID */
      uuid: "",
      /** 缺口移动的x轴 */
      moveX: 0,
      /** 缺口移动的y轴 */
      moveTop: 0,
      /** 加载遮罩标识 */
      loading: false,
      /** 校验中标识，防止重复提交 */
      verifying: false,
      /** 校验失败标识 */
      errorFlag: false,
      errorFlagMsg: "",
      /** 弹层是否展示在输入框下方 */
      placeBelow: false,
      /** 弹层定位样式 */
      popupStyle: {},
      /** 失败后重新取图的定时器 */
      errorTimer: null
    };
  },
  mounted() {
    this.$nextTick(this.updatePosition);
    window.addEventListener("scroll", this.updatePosition, true);
    window.addEventListener("resize", this.updatePosition);
    this.getImg();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updatePosition, true);
    window.removeEventListener("resize", this.updatePosition);
    clearTimeout(this.errorTimer);
    this.unbindMouse();
  },
  methods: {
    /** 根据参考元素计算弹层位置（fixed 定位，避免被父级 overflow 裁剪） */
    updatePosition() {
      const anchor =
        this.anchor && this.anchor.getBoundingClientRect
          ? this.anchor
          : this.$el.parentElement;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      if (!rect.width && !rect.height) return;
      // 上方空间不足时展示在下方
      const isBelow = rect.top - POPUP_HEIGHT - 6 < 8;
      let left = rect.left + rect.width / 2 - POPUP_WIDTH / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - POPUP_WIDTH - 8));
      this.placeBelow = isBelow;
      this.popupStyle = {
        left: `${left}px`,
        top: isBelow
          ? `${rect.bottom + 8}px`
          : `${rect.top - POPUP_HEIGHT - 6}px`
      };
    },
    /** 获取拼图图片 */
    getImg() {
      this.loading = true;
      this.errorFlag = false;
      getImageVerifyCode({})
        .then(res => {
          this.loading = false;
          const data = res && res.data;
          if (!data) return;
          if (data.code == "0") {
            this.backgroupImg = `data:image/png;base64,${data.data.bigImagel}`;
            this.moveImg = `data:image/png;base64,${data.data.imagel}`;
            this.uuid = data.data.uuid;
            this.moveTop = data.data.width;
          } else {
            // 取图失败只提示，不自动重新请求，避免接口异常时循环请求
            this.errorFlag = true;
            this.errorFlagMsg = data.message || "拼图加载失败，请重试";
          }
        })
        .catch(() => {
          this.loading = false;
          this.errorFlag = true;
          this.errorFlagMsg = "拼图加载失败，请重试";
        });
    },
    /** 校验失败：提示后换一张 */
    showError(msg) {
      this.errorFlag = true;
      this.errorFlagMsg = msg || "验证失败，请重新滑动";
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(() => {
        this.reset();
      }, 800);
    },
    /** 换一张 */
    reset() {
      this.errorFlag = false;
      this.errorFlagMsg = "";
      this.moveX = 0;
      this.moveTop = 0;
      this.startX = 0;
      this.blcokLeft = 0;
      this.getImg();
    },
    /** 关闭弹层 */
    close() {
      this.unbindMouse();
      this.$emit("close");
    },
    /**
     * 校验结果，通过后把滑块定位值与后台返回的 id 抛给父组件
     * @return success(blcokLeft, id)
     */
    verify() {
      if (this.verifying) return;
      const blcokLeft = this.blcokLeft;
      const id = this.uuid;
      const params = {
        checkCodeLimitTime: blcokLeft,
        businessCode: id
      };
      if (!this.validator) {
        this.$emit("success", blcokLeft, id);
        return;
      }
      this.verifying = true;
      Promise.resolve(this.validator(params))
        .then(result => {
          this.verifying = false;
          const passed = result === true || (result && result.passed === true);
          if (passed) {
            this.$emit("success", blcokLeft, id);
          } else {
            this.showError(result && result.message);
          }
        })
        .catch(() => {
          this.verifying = false;
          this.showError("验证失败，请重新滑动");
        });
    },
    /** 开始滑动 */
    start(e) {
      this.startX = e.pageX;
      this.startMove = true;
      window.addEventListener("mousemove", this.move);
      window.addEventListener("mouseup", this.up);
    },
    /** 滑动中 */
    move(e) {
      if (!this.startMove) return;
      const moveX = e.pageX - this.startX;
      if (moveX <= 0) {
        this.blcokLeft = 0;
        this.moveX = 0;
      } else if (moveX <= MAX_SLIDE) {
        this.blcokLeft = moveX;
        this.moveX = moveX;
      } else if (moveX < MAX_SLIDE + 19) {
        this.blcokLeft = moveX;
        this.moveX = MAX_SLIDE;
      }
    },
    /** 松开滑块 */
    up() {
      this.unbindMouse();
      if (!this.startMove) return;
      this.startMove = false;
      // 未拖动不触发校验
      if (this.blcokLeft <= 0) return;
      this.verify();
    },
    /** 解绑鼠标事件 */
    unbindMouse() {
      window.removeEventListener("mousemove", this.move);
      window.removeEventListener("mouseup", this.up);
    }
  }
};
</script>

<style lang="scss" scoped>
.sup-name-verify {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: visible;
}
.verify-popup {
  position: fixed;
  z-index: 3000;
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  &::before,
  &::after {
    position: absolute;
    content: "";
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
  }
  &::before {
    bottom: -11px;
    left: 50%;
    margin-left: -11px;
    border-top: 11px solid rgba(0, 0, 0, 0.1);
  }
  &::after {
    bottom: -11px;
    left: 50%;
    margin-left: -11px;
    border-top: 11px solid #ffffff;
  }
  &.is-below {
    &::before {
      top: -11px;
      bottom: auto;
      border-top: none;
      border-bottom: 11px solid rgba(0, 0, 0, 0.1);
    }
    &::after {
      top: -11px;
      bottom: auto;
      border-top: none;
      border-bottom: 11px solid #ffffff;
    }
  }
  .title {
    font-size: 14px;
    color: #333;
    display: flex;
    justify-content: space-between;
    padding: 10px 20px 10px;
    user-select: none;
    .text {
      font-size: 13px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4a4a4a;
    }
    .button-group {
      display: flex;
      align-items: center;
    }
    .refresh {
      cursor: pointer;
      .el-icon-refresh {
        font-size: 15px;
        color: #0089ef;
        margin-right: 6px;
      }
      span {
        font-size: 13px;
        color: #0089ef;
      }
    }
    .iconClose {
      margin-left: 10px;
      cursor: pointer;
      .el-icon-close {
        font-size: 16px;
        color: #cccccc;
      }
    }
  }
  .img {
    width: 360px;
    height: 140px;
    position: relative;
    margin: 0 auto;
    user-select: none;
    img {
      width: 100%;
      height: 100%;
    }
    .backgroup-img {
      width: 360px;
      height: 140px;
    }
    .move-img {
      width: 55px;
      height: 45px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .slide {
    width: 358px;
    height: 44px;
    background: #f2f2f2;
    border-radius: 23px;
    border: 1px solid #cacaca;
    box-sizing: border-box;
    position: relative;
    margin: 10px auto 0;
    &::before {
      position: absolute;
      content: attr(data-placeholder);
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #4a4a4a;
      width: 100%;
      height: 100%;
      text-indent: 64px;
    }
    .block {
      margin-top: -5px;
      margin-left: -5px;
      width: 55px;
      height: 55px;
      border-radius: 50%;
      position: absolute;
      top: 0;
      cursor: pointer;
      background-image: url("../images/slider.png");
      background-size: 100%;
    }
  }
  .slider-mask {
    position: absolute;
    left: 0;
    top: 0;
    height: 42px;
    transition: background 0.4s ease;
    .slider-mask-left {
      background: url("../images/sliderleft.png") no-repeat;
      width: 26px;
      height: 42px;
      float: left;
    }
    .slider-mask-left-errorleft {
      background: url("../images/slidererrleft.png") no-repeat;
      background-size: 100%;
      transition: background-position 0.5s;
    }
    .slider-mask-center {
      background: url("../images/slidercenter.png");
      margin-left: 24px;
      margin-right: 25px;
      height: 42px;
      overflow: hidden;
    }
    .slider-mask-left-errorcenter {
      background: url("../images/slidererrcenter.png");
      background-size: 100%;
      transition: background-position 0.5s;
    }
    .slider-mask-right {
      background: url("../images/sliderright.png") no-repeat;
      display: none;
      width: 26px;
      height: 42px;
      position: absolute;
      right: 0;
      top: 0;
    }
    .slider-mask-left-errorright {
      background: url("../images/slidererrright.png") no-repeat;
      background-size: 100%;
      transition: background-position 0.5s;
    }
  }
  .loading {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    flex-direction: column;
  }
}
</style>
